module.exports = __webpack_public_path__ + "static/ic-dado-10ed82cdf345f47f924647ccaa5e1afd.png";